// removed by extract-text-webpack-plugin
module.exports = {"root":"session-organization-tutorial--root--2hBFD9-c","content":"session-organization-tutorial--content--1jgQvoBI","title":"session-organization-tutorial--title--3IEfsN6w","logo":"session-organization-tutorial--logo--3Hx3dkR0","header":"session-organization-tutorial--header--32tB2t2T","menu":"session-organization-tutorial--menu--1_1jGwBL"};


//////////////////
// WEBPACK FOOTER
// ./components/session-organization-tutorial/styles.css
// module id = ./components/session-organization-tutorial/styles.css
// module chunks = 0